function initKnowledgePanels() {

    const panels = document.querySelectorAll(
        '.eg-knowledge-panel'
    );

    panels.forEach(panel => {

        if (panel.dataset.initialized) {
            return;
        }

        panel.dataset.initialized = true;

        const toggle =
            panel.querySelector(
                '.eg-knowledge-panel__toggle'
            );

        toggle?.addEventListener('click', () => {

            const isOpen =
                panel.classList.contains('is-open');

            panels.forEach(item =>
                item.classList.remove('is-open')
            );

            if (!isOpen) {
                panel.classList.add('is-open');
            }
        });
    });
}

document.addEventListener(
    'DOMContentLoaded',
    initKnowledgePanels
);

document.addEventListener(
    'shopify:section:load',
    initKnowledgePanels
);
